/**
 * @license The MIT License (MIT)
 * @copyright Igor Zaporozhets <i.zaporozhets@infomir.com>
 */

'use strict';

var keys      = require('stb-keys'),
    Component = require('stb-component'),
    List      = require('./content.list'),
    AppButton = require('./app.button');


/**
 * Create top-level container for all content elements in Prime Launcher.
 *
 * @param {Object} config - init parameters
 * @param {Object} config.provider - uniform data provider/collector of other data sources
 *
 * @constructor
 */
// eslint-disable-next-line max-lines-per-function
function ContentBoard ( config ) {
    var offset = 0,
        count  = 30,
        self   = this,
        ready  = false,

        providers  = [],
        rows       = [],
        imageCache = [];

    this.apps = [];
    this.appInFocus = false;
    this.$focusLine = null;

    this.focusIndex = 0;

    this.move = function ( direction ) {
        var scrollTop,
            focusIndex;

        if ( direction === keys.down ) {
            if ( self.focusIndex < self.apps.length - 1 ) {
                focusIndex = self.focusIndex + 1;
            } else {
                return false;
            }

            if ( self.focusIndex > 0 ) {
                scrollTop = self.apps[self.focusIndex].list.height;
                self.$node.scrollTop += scrollTop;
            }

            self.focusIndex = focusIndex;
        } else if ( direction === keys.up ) {
            if ( self.focusIndex > 0 ) {
                focusIndex = self.focusIndex - 1;
                scrollTop = self.apps[focusIndex].list.height;
                self.$node.scrollTop -= scrollTop;
                self.focusIndex = focusIndex;
            }
        } else {
            return false;
        }

        self.emit('focus:row', {
            direction: direction,
            focusIndex: self.focusIndex
        });

        if ( self.$focusLine ) {
            self.$focusLine.classList.remove('focus');
        }
        self.$focusLine = self.apps[self.focusIndex].$line;
        self.$focusLine.classList.add('focus');

        return true;
    };

    this.listKeydown = function ( event ) {
        if ( !ready ) {
            return;
        }

        if ( !event.stop ) {
            if ( event.code === keys.up || event.code === keys.down ) {
                if ( self.move(event.code) ) {
                    self.apps[self.focusIndex].list.focus();
                }
            } else if ( event.code === keys.left ) {
                if ( self.apps[self.focusIndex].list.$node.firstChild === self.apps[self.focusIndex].list.$focusItem ) {
                    self.apps[self.focusIndex].app.focus();
                }
            }
        }
    };

    this.appButtonKeydown = function ( event ) {
        if ( !ready ) {
            return;
        }

        if ( event.code === keys.up || event.code === keys.down ) {
            if ( self.move(event.code) ) {
                self.apps[self.focusIndex].app.focus();
            }
        } else if ( event.code === keys.right ) {
            self.apps[self.focusIndex].list.focus();
            // self.apps[self.focusIndex].list.focusIndex(0);
        }
    };

    config.events.mousewheel = function ( event ) {
        // scrolling by Y axis
        config.events.keydown(event.wheelDeltaY > 0 ? {code: keys.up} : {code: keys.down});
        event.preventDefault();
    };

    Component.call(self, config);

    this.$node.className = 'container content-board';

    // self.$appsList = self.$node.appendChild(document.createElement('div'));
    // self.$appsList.className = 'applications-list';
    //
    // self.$board = self.$node.appendChild(document.createElement('div'));
    // self.$board.className = 'board';

    config.provider.load({
        offset: offset,
        count: count
    }, function () {
        while ( offset < count ) {
            if ( config.provider.providers[offset] ) {
                if ( config.provider.providers[offset].application.packageName !== 'magcore-app-records' ) {
                    providers.push(config.provider.providers[offset]);
                    rows.push(config.provider.rows[offset]);

                    self.addContentList(config.provider.providers[offset], config.provider.rows[offset]);
                }
            }

            ++offset;
        }

        setTimeout(function () {
            var uniqueUris = [],
                iconNormal, iconActive;

            providers.forEach(function ( provider ) {
                var icons = provider.application.uris.icons;

                iconNormal = new Image();
                iconActive = new Image();

                iconNormal.src = icons.primeLogoNormal;
                iconActive.src = icons.primeLogoActive;

                imageCache.push(iconNormal, iconActive);

                if ( provider.application.name === 'Apps' ) {
                    iconNormal = new Image();
                    iconActive = new Image();

                    iconNormal.src = icons.shadowNormal;
                    iconActive.src = icons.shadowActive;

                    imageCache.push(iconNormal, iconActive);
                }
            });

            rows.forEach(function ( row, rowIndex ) {
                var item, index, icons;

                for ( index = 0; index < row.length; index += 1 ) {
                    item = row[index];

                    if ( rowIndex ) {
                        icons = {
                            normal: item.data.icon ? item.data.icon.normal : null,
                            active: item.data.icon ? item.data.icon.active : null
                        };
                    } else {
                        icons = {
                            normal: item.data.icons.primeLogoNormal,
                            active: item.data.icons.primeLogoActive
                        };
                    }

                    if ( icons.normal && uniqueUris.indexOf(icons.normal) === -1 ) {
                        uniqueUris.push(icons.normal);

                        iconNormal = new Image();
                        iconActive = new Image();

                        iconNormal.src = icons.normal;
                        iconActive.src = icons.active;

                        imageCache.push(iconNormal, iconActive);
                    }
                }
            });
        }, 0);

        setTimeout(function () {
            self.children[self.focusIndex].focus();
            self.$focusLine = self.apps[self.focusIndex].$line;
            self.$focusLine.classList.add('focus');
            self.emit('ready');
            ready = true;
        }, 0);
    });
}


// inheritance
ContentBoard.prototype = Object.create(Component.prototype);
ContentBoard.prototype.constructor = ContentBoard;

// set component name
ContentBoard.prototype.name = 'content-board';


ContentBoard.prototype.addContentList = function ( provider, data ) {
    var self = this,
        $line, appButton, config, contentList;

    if ( !data || data.length === 0 ) {
        return;
    }


    $line = document.createElement('div');
    appButton = new AppButton(provider);
    config = {
        data: data,
        provider: provider
    };
    contentList = new List(config);

    if ( config.listClass ) {
        $line.className = 'content-line-' + config.listClass;
    } else {
        $line.className = 'content-line';
    }

    if ( provider.instance && provider.instance.addListener ) {
        provider.instance.addListener('add', function ( event ) {
            event.data.colors = provider.colors;
            contentList.addContentItem(event);
        });

        provider.instance.addListener('remove', function ( event ) {
            contentList.removeContentItem(event);
        });

        provider.instance.addListener('update', function ( event ) {
            console.log(event);
        });
    }

    this.$node.appendChild($line);
    // self.$board.appendChild(contentList.$node);
    self.apps.push({
        $line: $line,
        app: appButton,
        list: contentList
    });
    $line.appendChild(appButton.$node);
    $line.appendChild(contentList.$node);
    // self.lists.push(contentList);
    self.add(contentList);
    contentList.height = contentList.$node.offsetHeight;

    // if ( self.apps.length > 2 ) {
    //     // TODO: hack for different list heights
    //     self.$appsList.appendChild(document.createElement('div'));
    //     self.$appsList.lastChild.className = 'app-separator';
    // }

    // if ( self.apps.length > 3 ) {
    //     // TODO: hack for different list heights
    //     self.$appsList.appendChild(document.createElement('div'));
    //     self.$appsList.lastChild.className = 'app-separator';
    // }

    // margin = (contentList.$node.children[0].offsetHeight - 120) / 2;
    // appButton.$node.style.height = contentList.height - margin + 'px';

    // console.log('appButton.$node.children[0].offsetHeight ' + appButton.$node.children[0].offsetHeight);
    // if ( self.apps.length > 1 ) {
    //     appButton.$node.style.marginTop = margin + 'px';
    // }

    // self.$appsList.appendChild(appButton.$node);

    contentList.addListener('keydown', self.listKeydown);
    appButton.addListener('keydown', self.appButtonKeydown);
};


module.exports = ContentBoard;
